import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { message: String, confirmation: String, completionUrl: String }

  async open(event) {
    event.preventDefault()

    if (navigator.share) {
      try {
        await navigator.share({
          // Keep the explanation and URL in one payload. Some iOS share targets
          // discard separate title/text fields when a URL is also supplied.
          text: this.messageValue
        })
        await this.notifyCompletion()
        return
      } catch (error) {
        if (error?.name === "AbortError") return
      }
    }

    this.copyMessage()
  }

  copyMessage() {
    const original = this.element.innerHTML
    const confirm = () => {
      this.element.textContent = this.hasConfirmationValue ? this.confirmationValue : "Invitation copied"
      setTimeout(() => { this.element.innerHTML = original }, 1800)
    }

    if (window.webkit?.messageHandlers?.nativeClipboard) {
      window.webkit.messageHandlers.nativeClipboard.postMessage(this.messageValue)
      confirm()
      this.notifyCompletion()
      return
    }

    if (navigator.clipboard?.writeText) {
      navigator.clipboard.writeText(this.messageValue).then(() => {
        confirm()
        this.notifyCompletion()
      }).catch(() => this.fallbackCopy(confirm))
    } else {
      this.fallbackCopy(confirm)
    }
  }

  fallbackCopy(callback) {
    const field = document.createElement("textarea")
    field.value = this.messageValue
    field.style.cssText = "position:fixed;top:-9999px;left:-9999px;opacity:0;"
    document.body.appendChild(field)
    field.focus()
    field.select()
    try {
      document.execCommand("copy")
      callback()
      this.notifyCompletion()
    } catch (_) {}
    document.body.removeChild(field)
  }

  notifyCompletion() {
    if (!this.hasCompletionUrlValue) return

    return fetch(this.completionUrlValue, {
      method: "POST",
      headers: { "X-CSRF-Token": document.querySelector("meta[name='csrf-token']")?.content },
      credentials: "same-origin",
      keepalive: true
    }).then((response) => {
      if (!response.ok) throw new Error(`Completion returned ${response.status}`)
    }).catch((error) => console.warn("[share] completion failed", error))
  }
}
